import { createContext } from "react";
import { CustomerContractEditorStore } from "./CustomerContractEditorStore";

export const CustomerContractEditorStoreContext =
  createContext<CustomerContractEditorStore>(null);
